import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useForm } from 'react-hook-form';
import AppSidebar from '../../components/AppSidebar';
import AppHeader from '../../components/AppHeader';
import PageHeader from '../../components/PageHeader';
import RequestHandler from './RequestHandler';
import configurationService from '../../services/ConfigurationsServices';
import { useAuth } from '../../contexts/AuthContext';
import { ToastContainer, toast } from 'react-toastify';

const TIMEZONE_API_URL = 'https://timeapi.io/api/timezone/availabletimezones';
const Localization = () => {
    const { register, handleSubmit, formState: { errors }, reset } = useForm();
    const [timezones, setTimezones] = useState([]);
    const { user } = useAuth();

    useEffect(() => {
        const fetchTimezones = async () => {
            try {
                const response = await axios.get(TIMEZONE_API_URL);
                console.log("Fetched Timezones:", response.data);
                setTimezones(response.data?.map(timezone => ({
                    id: timezone,
                    name: timezone,
                })));
            } catch (error) {
                console.error('Failed to fetch timezones:', error);
            }
        };

        fetchTimezones();
    }, []);

    const onSubmit = async (data) => {
        const requestBody = RequestHandler(data, "Localization", "configurations", null, true, user);
        console.log("Request Body:", requestBody);

        try {
            const response = await configurationService.createConfiguration(requestBody);

            if (response?.data?.status) {
                toast.success(response?.data?.message);
                reset();
            }
        } catch (error) {
            if (error?.response) {
                const validationErrors = error?.response?.data?.data?.errors || [];
                validationErrors.forEach(err => {
                    console.error(`${err?.field}: ${err?.message}`);
                    toast.error(`${err?.field}: ${err?.message}`);
                });
            } else {
                console.error('Failed to submit data:', error);
                toast.error('Something went wrong.');
            }
        }
    };

    return (
        <>
            <AppSidebar />
            <div className="main-content">
                <AppHeader />
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-10 col-xl-12">
                            <PageHeader title='Localization' />
                            <div className="card p-4">
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="row">
                                        {/* Date Format Select */}
                                        <div className="col-12 col-md-12">
                                            <div className="form-group">
                                                <label className="form-label">Date Format</label>
                                                <select
                                                    {...register('dateFormat', { required: 'Date format is required' })}
                                                    className="form-select"
                                                    aria-label="Date Format"
                                                >
                                                    <option value="">Select Date Format</option>
                                                    <option value="d-m-y">d-m-y</option>
                                                    <option value="d/m/y">d/m/y</option>
                                                    <option value="d.m.y">d.m.y</option>
                                                    <option value="m-d-y">m-d-y</option>
                                                    <option value="m/d/y">m/d/y</option>
                                                    <option value="m.d.y">m.d.y</option>
                                                </select>
                                                {errors.dateFormat && <div className="text-danger">{errors.dateFormat?.message}</div>}
                                                <hr />
                                            </div>
                                        </div>
                                        {/* Time Format Select */}
                                        <div className="col-12 col-md-12">
                                            <div className="form-group">
                                                <label className="form-label">Time Format</label>
                                                <select
                                                    {...register('timeFormat', { required: 'Time format is required' })}
                                                    className="form-select"
                                                    aria-label="Time Format"
                                                >
                                                    <option value="">Select Time Format</option>
                                                    <option value="12h">12 hours</option>
                                                    <option value="24h">24 hours</option>
                                                </select>
                                                {errors.timeFormat && <div className="text-danger">{errors.timeFormat?.message}</div>}
                                                <hr />
                                            </div>
                                        </div>
                                        {/* Timezone Select */}
                                        <div className="col-12 col-md-12">
                                            <div className="form-group">
                                                <label className="form-label">Default Timezone</label>
                                                <select
                                                    {...register('timeZone')}
                                                    className="form-select"
                                                    aria-label="Default Timezone"
                                                >
                                                    <option value="">Select Timezone</option>
                                                    {timezones?.map(timezone => (
                                                        <option key={timezone?.id} value={timezone?.id}>{timezone?.name}</option>
                                                    ))}
                                                </select>
                                                {errors.timeZone && <div className="text-danger">{errors.timeZone?.message}</div>}
                                                <hr />
                                            </div>
                                        </div>
                                        {/* Language Select */}
                                        <div className="col-12 col-md-12">
                                            <div className="form-group">
                                                <label className="form-label">Default Language</label>
                                                <select
                                                    {...register('languageFormat', { required: 'Language is required' })}
                                                    className="form-select"
                                                    aria-label="Default Language"
                                                >
                                                    <option value="">Select Language</option>
                                                    <option value="en">English</option>
                                                    <option value="hin">Hindi</option>
                                                    <option value="arab">Arabic</option>
                                                </select>
                                                {errors.languageFormat && <div className="text-danger">{errors.languageFormat?.message}</div>}
                                                <hr />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='text-end'>
                                        <button type="submit" className="btn btn-primary">
                                            Save
                                        </button>
                                    </div>
                                </form>
                                <hr className="my-5" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    );
};

export default Localization;
